import { PaletteOptions } from "@mui/material"
/**
 * Light palette
 */
const palette: PaletteOptions = {
  primary: {
    main: "#003D7B"
  },
  label: {
    main: "#BF954B"
  },
  common: {
    black: "rgba(0, 0, 0, 0.87)"
  },
  extends: {
    lightGray: {
      main: "#F6F6F7"
    },
    paperGray: {
      main: "#f0f0f0"
    }
  }
}

export default palette
